import styles from "./LocationGymsFilter.module.scss";
import { Form, Select, Slider } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import CustomButton from "../../../components/ui/CustomButton/CustomButton";
import searchIcon from "../../../assets/images/icons/search-white.svg";
import { IClassCategory } from "../../../models/ClassEvent";

const { Option } = Select;

interface ILocationGymsFilter {
  allCategories: IClassCategory[];
  distance: [number, number];
  categories: string[];
  amenities: string[];
  onChangeAmenities: (value: string[]) => void;
  onChangeDistance: (value: [number, number]) => void;
  onChangeCategories: (value: string[]) => void;
  onSearch: () => void;
  onResetAll: () => void;
}

const LocationGymsFilter: React.FC<ILocationGymsFilter> = ({
  allCategories,
  distance,
  categories,
  amenities,
  onChangeAmenities,
  onChangeDistance,
  onChangeCategories,
  onSearch,
  onResetAll,
}) => {
  const { t } = useTranslation();

  const servicesOffers = [
    { id: "Lockers", label: t("Lockers") },
    { id: "Shower", label: t("Shower") },
    { id: "Parking", label: t("Parking") },
    { id: "WiFi", label: t("WiFi") },
    { id: "WaterDispenser", label: t("WaterDispenser") },
    { id: "TowelService", label: t("TowelService") },
    { id: "SaunaAndSteamRoom", label: t("SaunaAndSteamRoom") },
    { id: "SwimmingPool", label: t("SwimmingPool") },
    { id: "JuiceBarCafé", label: t("JuiceBarCafé") },
    { id: "ChildcareServices", label: t("ChildcareServices") },
    { id: "BikeRacks", label: t("BikeRacks") },
    { id: "LoungeArea", label: t("LoungeArea") },
  ];

  return (
    <div className={styles.headerBox}>
      <Form.Item
        className={`form-item__select horizontal ${styles.selectWrapper}`}
        label={t("Categories")}
      >
        <Select
          mode={"multiple"}
          className={`select multiple`}
          variant={"borderless"}
          optionFilterProp={"children"}
          showSearch={true}
          placeholder={t("All")}
          value={categories}
          onChange={onChangeCategories}
        >
          {allCategories.map((el) => (
            <Option value={el.id} key={el.id}>
              {el.name}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        className={`form-item__select horizontal ${styles.selectWrapper}`}
        label={t("Amenities")}
      >
        <Select
          mode={"multiple"}
          className={`select multiple`}
          variant={"borderless"}
          optionFilterProp={"children"}
          showSearch={true}
          placeholder={t("All")}
          value={amenities}
          onChange={onChangeAmenities}
        >
          {servicesOffers.map((el) => (
            <Option value={el.id} key={el.id}>
              {el.label}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        className={`form-item__select horizontal ${styles.selectWrapper}`}
        label={t("Distance")}
      >
        <div>
          <span className={styles.distanceText}>{`${distance[0]} - ${distance[1]} km`}</span>

          <Slider
            range
            defaultValue={[0, 20]}
            min={0}
            max={20}
            step={1}
            styles={{
              rail: {
                backgroundColor: "#E2E8F0",
                height: 6,
              },
              track: {
                backgroundColor: "#FF8C42",
                height: 6,
              },
              handle: {
                borderColor: "#FF8C42 !important",
              },
            }}
            value={distance}
            onChange={(value) => onChangeDistance(value as [number, number])}
          />
        </div>
      </Form.Item>

      <div className={styles.btnWrapper}>
        <CustomButton
          text={""}
          type={"button"}
          typeStyle={"fill"}
          icon={searchIcon}
          altIcon={"search"}
          functionOnClick={onSearch}
        />

        <span className={styles.reset} onClick={onResetAll}>
          {t("Reset")}
        </span>
      </div>
    </div>
  );
};

export default LocationGymsFilter;
